import { render, staticRenderFns } from "./upload_documentation_byinvitation_byuser.vue?vue&type=template&id=3204c031&scoped=true"
import script from "./upload_documentation_byinvitation_byuser.vue?vue&type=script&lang=js"
export * from "./upload_documentation_byinvitation_byuser.vue?vue&type=script&lang=js"
import style0 from "./upload_documentation_byinvitation_byuser.vue?vue&type=style&index=0&id=3204c031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3204c031",
  null
  
)

export default component.exports